export default "__VITE_ASSET__TCnLSsID__"